import React from "react";
import { useQuery } from "react-query";
import { LoadingDots, Select } from "web-ui";

import { getCrashesVersions } from "api/dashboardBackend";
import styles from "components/crashes/CrashesVersionSelect.module.scss";
import type { PlatformId } from "util/platform";
import { semVerString } from "util/version";

interface Props {
  platformId: PlatformId;
  queryPrompt: string;
  value: string;
  onChangeCallback: (value: string) => void;
}

const CrashesVersionSelect = ({
  platformId,
  queryPrompt,
  value,
  onChangeCallback,
}: Props) => {
  const { data, error, isLoading } = useQuery({
    queryFn: () => getCrashesVersions(platformId),
    queryKey: [platformId, "crashes-version-select"],
  });

  return data && data.length > 0 ? (
    <div>
      <span className={styles.queryText}>{queryPrompt}</span>
      <Select
        className={styles.select}
        onChange={e => onChangeCallback(e.target.value)}
        options={data.map(version => ({
          text: semVerString(version),
          value: semVerString(version),
        }))}
        value={value}
      />
    </div>
  ) : isLoading ? (
    <LoadingDots type="screen-white" />
  ) : (
    <>
      {`Error fetching ${queryPrompt}: ${error}`}
      <br />
    </>
  );
};

export default CrashesVersionSelect;
